import React from 'react'
import { css } from 'theme-ui'
import { Card, Text, Heading, Box, Button } from 'theme-ui'
import NewsletterForm from '@components/NewsletterForm'
// import useMailChimp from '@helpers/useMailChimp'
import { FaEnvelope, FaWind } from 'react-icons/fa'
import { Link } from 'gatsby'

const styles = {
  card: {
    position: `relative`
  },
  wrapper: {
    maxWidth: 500,
    textAlign: `center`,
    mx: `auto`,
    py: 3
  },
  icons: {
    display: [`none`, `none`, `block`],
    position: `absolute`,
    top: `-3rem`,
    left: `5rem`,
    svg: {
      display: `block`
    }
  },
  envelope: {
    fontSize: `9rem`,
    color: `omegaDarker`,
    transform: `rotate(-60deg)`,
    ml: `1rem`
  },
  wind: {
    fontSize: `7rem`,
    color: `omegaLight`,
    transform: `rotate(120deg)`,
    mt: `0.5rem`,
    ml: `-3rem`
  },
  form: {
    maxWidth: 300,
    mx: `auto`,
    mt: 4
  }
}

const ContactExpanded = ({ simple }) => {
  return (
    <Card variant='paper' sx={styles.card}>
      <Box sx={styles.wrapper}>
        {!simple && (
          <Box sx={styles.icons}>
            <FaEnvelope css={css(styles.envelope)} />
            <FaWind css={css(styles.wind)} />
          </Box>
        )}
        <Heading variant='h2'>Work with us</Heading>
        <Text variant='p'>
          Are we a good fit for your project?
          <br />
          Get in touch and find out how we can help.
        </Text>
        <Box sx={styles.form}>
          <Button as={Link} to='/contact' variant='primary'>
            Contact Us
          </Button>
        </Box>
      </Box>
    </Card>
  )
}

ContactExpanded.defaultProps = {
  simple: false
}

export default ContactExpanded
